module.exports = __webpack_public_path__ + "img/system.8f062138.svg";